import React, { memo, Fragment } from 'react'
import {
  useFloatingActionMenu,
  FloatingActionMenuProps,
} from './useFloatingActionMenu'
import styles from './FloatingActionMenu.module.scss'
import FeedbackBox from './FeedbackBox/FeedbackBox'
import OpeningHoursBox from './OpeningHoursBox/OpeningHoursBox'

const FloatingActionMenu: React.FC<FloatingActionMenuProps> = (
  props: FloatingActionMenuProps
) => {
  const {
    Buttons,
    showFeedbackBox,
    showOpeningHoursBox,
    areOpeningHoursPublished,
    areFeedbacksPublished,
    isChatWithAIPublished,
    setShowFeedbackBox,
    setShowOpeningHoursBox,
    handleBtnClick,
  } = useFloatingActionMenu(props)

  return (
    <Fragment>
      <div className={styles['menu-tooltip-container']}>
        <aside className={styles['menu-tooltip']}>
          <input
            type='checkbox'
            id='toggle'
            className={styles['check-toggle']}
          />
          <label htmlFor='toggle' className={styles.toggle}>
            <i className='bi bi-plus'></i>
          </label>
          {areOpeningHoursPublished && (
            <li style={{ ['--i' as any]: 0 }} className={styles['circle-box']}>
              <button
                type='button'
                id='btnOpeningHours'
                className={styles.anchor}
                onClick={(e) => {
                  e.preventDefault()
                  handleBtnClick(Buttons.OpeningHours)
                }}
              >
                <i className='bi bi-clock'></i>
              </button>
            </li>
          )}
          {areFeedbacksPublished && (
            <li style={{ ['--i' as any]: 1 }} className={styles['circle-box']}>
              <button
                type='button'
                id='btnFeedback'
                className={styles.anchor}
                onClick={(e) => {
                  e.preventDefault()
                  handleBtnClick(Buttons.Feedback)
                }}
              >
                <i className='bi bi-chat-heart'></i>
              </button>
            </li>
          )}
          {isChatWithAIPublished && (
            <li style={{ ['--i' as any]: 2 }} className={styles['circle-box']}>
              <button
                type='button'
                id='btnChatbot'
                className={styles.anchor}
                onClick={(e) => {
                  e.preventDefault()
                  handleBtnClick(Buttons.Chatbot)
                }}
              >
                <i className='bi bi-robot'></i>
              </button>
            </li>
          )}
        </aside>
      </div>

      {showFeedbackBox && (
        <FeedbackBox
          title='Share Your Experience'
          setShowFeedbackBox={setShowFeedbackBox}
        />
      )}

      {showOpeningHoursBox && (
        <OpeningHoursBox
          title='Share Your Experience'
          setShowOpeningHoursBox={setShowOpeningHoursBox}
        />
      )}
    </Fragment>
  )
}

export default memo(FloatingActionMenu)
